export enum AudienceDetailPrefix {
  PerennialPriority = 'PP: ',
  MissionCriticalPriority = 'MCP: ',
  JourneyStep = 'JS: ',
  PerennialQuestion = 'PQ: '
}
